<template>
  <img src="@/assets/img/info-page/info.jpg" alt="" />
</template>

<script>
export default {
  name: "infoPage",
};
</script>

<style>
img {
  max-width: 100%;
}
</style>